module.exports = __webpack_public_path__ + "img/Radio.125fa663.svg";